import { render, staticRenderFns } from "./TravelPlanList.vue?vue&type=template&id=47532c88"
import script from "./TravelPlanList.vue?vue&type=script&lang=js"
export * from "./TravelPlanList.vue?vue&type=script&lang=js"
import style0 from "./TravelPlanList.vue?vue&type=style&index=0&id=47532c88&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports